import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createSimpleUser } from '../user/SimpleUser';

/**
 * # EmpPos
 *
 * EmpPos을 설명하세요.
 */
export const EmpPos = types
  .model('EmpPos')
  // --------------------------------------------------------------------------
  .props({
    regDt: types.optional(types.number, 0),
    updDt: types.optional(types.number, 0),
    empPosSid: types.optional(types.number, 0),
    empPosNm: types.optional(types.string, ''),
    empPosLv: types.optional(types.number, 0),
    empPosOrdr: types.optional(types.number, 0),
    regUser: types.maybeNull(createSimpleUser()),
    updUser: types.maybeNull(createSimpleUser()),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model empPos --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IEmpPos;
      (Object.keys(newProps) as TEmpPosKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TEmpPos = Instance<typeof EmpPos>;
type TEmpPosSnapshot = SnapshotOut<typeof EmpPos>;

export interface IEmpPos extends TEmpPos {}
export type TEmpPosKeys = keyof TEmpPosSnapshot & string;
export interface IEmpPosSnapshot extends TEmpPosSnapshot {}
export const createEmpPos = () => types.optional(EmpPos, {} as TEmpPos);
